export default __webpack_public_path__ + "static/media/img2.34499ed5.webp";